import { UtilityScripts } from "app/helpers/utility-scripts";

export class API {
	private httpService;
	private launchURLVO;
	private _uuid = "";
	private _authorization;
	private _isTerminated: boolean = false;
	constructor(
		private _httpService,
		private _launchURLVO,
		private authorization
	) {
		this.httpService = _httpService;
		this.launchURLVO = _launchURLVO;
		this._authorization = authorization;
	}
	public async sendStatements(statements: any) {
		if (!this.isTerminated) {
			this._uuid = UtilityScripts.getuuidv4();
			statements.id = this._uuid;
			const url: any = `${
				this.launchURLVO.endpoint
			}/statements?${this.getQueryStringForStatement()}`;
			const response: any = await this.httpService.ajaxXAPI(
				"PUT",
				url,
				JSON.stringify(statements),
				this.getHeader()
			);
			return response;
		}
		return "";
	}

	public sendTerminatedStatements(statements: any){
		this._uuid = UtilityScripts.getuuidv4();
			statements.id = this._uuid;
		const url: any = `${
			this.launchURLVO.endpoint
		}/statements?${this.getQueryStringForStatement()}`;

     console.log("calling fetch API for sending terminate statement on Player unload")
			  fetch(url, {
					keepalive: true,
					method: 'PUT',
					headers: this.getHeader(),
					body: JSON.stringify(statements)
				 }).then(response => {
          console.log('Response from Fetch call for Terminate Statement',response);
         }).catch(error => {
					console.error('Error in calling Terminate statement API:', error);
				 });
	}


	// get Statements
	public async getStatements() {
		const url: any = `${
			this.launchURLVO.endpoint
		}/statements?${this.getQueryStringForStatement()}`;
		const response: any = await this.httpService.ajaxXAPI(
			"GET",
			url,
			null,
			this.getHeader()
		);
		return response;
	}
	// sendState
	public async sendState(state_id, state, queryString) {
		if (!this.isTerminated) {
			const url: any =
				`${this.launchURLVO.endpoint}/activities/state` +
				`?stateId=${state_id}&${queryString}`;
			//const response: any = await this.httpService.post(url ,JSON.stringify(state), this.getHeader() );
			const response: any = await this.httpService
				.ajaxXAPI("POST", url, JSON.stringify(state), this.getHeader())
				.then(
					(res: any) => {
						console.log("Response ", res);
					},
					(error: any) => {
						console.log("Error ", error);
						if (error.status == "401") {
							alert(
								"You have been logged out and no further progress will be tracked. You will need to log in to continue taking the course."
							);
						}
					}
				);

			return response;
		}
		return "";
	}
	// getState
	public async getState(state_id, queryString) {
		const url: any =
			`${this.launchURLVO.endpoint}/activities/state` +
			`?stateId=${state_id}&${queryString}`;
		const response: any = await this.httpService.ajaxXAPI(
			"GET",
			url,
			"",
			this.getHeader()
		);
		return response;
	}

	public async getAgentProfile(agent) {
		let profile_id = "cmi5LearnerPreferences";
		const url: any =
			`${this.launchURLVO.endpoint}/agents/profile` +
			`?agent=${agent}&profileId=${profile_id}`;
		const response: any = await this.httpService.ajaxXAPI(
			"GET",
			url,
			"",
			this.getHeader()
		);
		return response;
	}

	public async sendAgentProfile(agent) {
		let profile_id = "cmi5LearnerPreferences";
		let obj: any = {};
		obj.languagePreference = "en-US";
		obj.audioPreference = "on";
		let profileVal = JSON.stringify(obj);
		const url: any =
			`${this.launchURLVO.endpoint}/agents/profile` +
			`?agent=${agent}&profileId=${profile_id}`;
		const response: any = await this.httpService.ajaxXAPI(
			"POST",
			url,
			profileVal,
			this.getHeader()
		);
		return response;
	}

	public async getLaunchData(queryString) {
		let state_id = "LMS.LaunchData";
		const url: any =
			`${this.launchURLVO.endpoint}/activities/state` +
			`?stateId=${state_id}&${queryString}`;
		const response: any = await this.httpService.ajaxXAPI(
			"GET",
			url,
			"",
			this.getHeader()
		);
		return response;
	}
	private getHeader() {
		const header = {
			Authorization: this._authorization,
			"content-type": "application/json",
			"X-Experience-API-Version": "1.0.3",
			/*'charset': 'utf-8'*/
		};
		return header;
	}
	private getQueryStringForStatement() {
		const query = "statementId=" + encodeURIComponent(this._uuid);
		return query;
	}
	public set isTerminated(bVal: boolean) {
		this._isTerminated = bVal;
	}
	public get isTerminated() {
		return this._isTerminated;
	}
}
